import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EducationAccordion = ({
  educationListBlock = [],
  updateEductionBlock,
  onDeleteEducationBlock,
  setEducationIndex,
}) => {
  const { t } = useTranslation();

  return (
    <div className="accordion-item bg-transparent border-0">
      {/* ------ toggle accordion button start ------ */}
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseThree"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseThree"
        >
          {t("Education")}
        </button>
      </h3>
      {/* ------ toggle accordion button end ------ */}
      {/* ----- eduction block list section start ----- */}
      <div
        id="panelsStayOpen-collapseThree"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          <div className="fields-group">
            {/* ------ education list section start ------ */}
            <div className="fields d-flex flex-column gap-3">
              {educationListBlock.map((education, index) => {
                return (
                  <div className="field" key={index}>
                    <div className="row g-3 align-items-center">
                      <div className="col-lg-3">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Degree")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                            {education.degree}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Year")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark">
                            {education.year}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Grade")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark">
                            {education.grade}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="d-flex align-items-center body-bg rounded-10 h-100 overflow-hidden border">
                          <span className="text-muted border-end py-3 px-3 lh-1">
                            {t("Institute")}
                          </span>
                          <p className="fw-bold ps-3 mb-0 text-dark text-truncate">
                            {education.institute}
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-1 action d-flex align-items-center justify-content-start gap-3">
                        <Link
                          to="#"
                          className="text-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#addEducationModal"
                          onClick={() => updateEductionBlock(education, index)}
                        >
                          <span className="d-block material-symbols-outlined">
                            edit
                          </span>
                        </Link>
                        <button
                          type="button"
                          className="btn p-0 border-0 bg-transparent text-danger"
                          onClick={() => onDeleteEducationBlock(index)}
                        >
                          <span className="d-block material-symbols-outlined">
                            delete
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {/* ------ education list section end ------ */}
            {/* ------ add education modal button start ------ */}
            <Link
              to="#"
              className="btn btn-outline-primary d-inline-flex align-items-center gap-1 mt-3"
              data-bs-toggle="modal"
              data-bs-target="#addEducationModal"
              onClick={() => {
                setEducationIndex(null);
              }}
            >
              <span className="d-block material-symbols-outlined">add</span>
              <span className="d-block">{t("Add Education")}</span>
            </Link>
            {/* ------ add education modal button end ------ */}
          </div>
        </div>
      </div>
      {/* ----- eduction block list section end ----- */}
    </div>
  );
};

export default EducationAccordion;
